<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import Overlay from '../components/overlay.svelte';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			blocks: ISbStoryData[];
			overlay_blocks: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();

	let overlay = $state<{ show: () => void }>();
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<div use:editable={content}>
	<!-- svelte-ignore a11y_click_events_have_key_events -->
	<div role="button" tabindex="0" onclick={() => overlay?.show()} class="cursor-pointer">
		{#each content.blocks || [] as block}
			<Blok content={block} />
		{/each}
	</div>

	{#if content.overlay_blocks?.length > 0}
		<Overlay bind:this={overlay}>
			{#each content.overlay_blocks as overlayBlock}
				<Blok content={overlayBlock} />
			{/each}
		</Overlay>
	{/if}
</div>
